export default __webpack_public_path__ + "static/media/html_original_wordmark_logo_icon_146478.5d00fa00.png";